import React, { useState, useEffect } from "react";
import { Button, Empty } from "antd";

import SubUserAddModal from "../SubUserAddModal";

import useMembersStore from "../../store/members.store";
import useSubUserStore from "../../store/subUserModal.store";
import { DatePicker, Space } from 'antd';


import "./mytimeSheet.scss";
import FilterTimeSheet from "../filterTimeSheet";
import MyTimeSheetTable from "../MyTimeSheetTable";
import useMyTimeSheetStore from "../../store/mytimesheet";
import MyLeaves from "../myLeaves";

const timeSheetTitlesLeaves = [
    "Select",
    "S. No.",
    "QH User ID",
    "Emp ID",
    "Name",
    "Role",
    "Project",
    "Presence Status", //online, away, not loggin
    "Total Leaves", 
    "SL",
    "EL",
    "LOP",
    "Start Date",
    "End Date", 
    "Approval Status", //Accept, Reject, Pending
    "Approval Date",
    "Leave Req Date",
    "Comments"
];

const timeSheetTitlesDaily = [
    "Select",
    "S. No.",
    "QH User ID",
    "Emp ID",
    "Name",
    "Role",
    "Date",
    "Day",
    "Project",    
    "Presence Status", //online, away, not loggin
    "Attendance Status", //online, away, not loggin
    "In Time",
    "Out Time",
    "Leave Type", //attendent_status = on_leave, absent, present
    "Total Hrs", //total hrs
    "Extra Hrs",    
    "Comments"
];

//need to select month
const timeSheetTitlesMonthly = [
    "Select",
    "S. No.",
    "Date",
    "Day",  
    "Project",      
    "Attendance Status", //attendent_status = on_leave, absent, present    
    "In Time",
    "Out Time",
    "Leave Type", //attendent_status = on_leave, absent, present    
    "Total Hrs", //total hrs
    "Extra Hrs", 
    "Comments",
];

//need to select year
const timeSheetTitlesYearly = [
    "Select",
    "S. No.",
    "Month",
    "Project",
    "Total Days",
    "Total Hrs",    
    "Extra Hrs",
    "Leaves",
    "Comments",
];
const MonthsName = [
    "Jan",
    "Feb",
    "March",
    "April",
    "May",    
    "June",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];


function MyTimeSheet() {
    const [currentView, setCurrentView] = useState("daily");

    const { getTeamMembers, teamMembers } =
        useMembersStore();

    const {doCheckinCheckout,getTodaysAttendance,attendanceUpdateFlag,
           dailyAttendance,resetFlags,getMonthlyAttendance,monthlyAttendance,yearlyAttendance,getYearlyAttendance} = useMyTimeSheetStore()

    const userData = JSON.parse(localStorage.getItem("userDetails"));           
    const today =  new Date();
    const month = today.getMonth();
    const year = today.getFullYear();
    const date = today. getDate();
    useEffect(() => {
        resetFlags()
        getTodaysAttendance(year,month,date);
    }, []);

    useEffect(() => {
        if(attendanceUpdateFlag){
            resetFlags();
            getTodaysAttendance(year,month,date);
        }
    }, [attendanceUpdateFlag]);
    
    //wait for page to be reandered
    if(dailyAttendance == null) return;

    const isValid = (value) =>{
        if ((value == null) || (value == undefined) || (value == "")){
            return false
        }else{
            return true
        }
    }

    const getAttStatus = (member) =>{
        if(member?.leavetype == "" && member?.leaveapprovalstatus != "APPROVED"){
            return member?.attendancestatus==""?"NOT-IN":member?.attendancestatus
        }else{
            return "On Leave"
        }
    }

    const monthlyData = monthlyAttendance?.map((member, idx) => {
        return {
            select:"",
            id:idx+1,
            date:member?.date.currentdatestr,
            day:member?.date.currentday,            
            project:userData.project,
            attaendancestatus:getAttStatus(member), //IN, OUT,NOT-IN,ON_LEAVE
            intime:member.date?.intime,
            outtime:member.date?.outtime,
            leavestype:member?.leavetype, //NO LEAVE,SICK_LEAVE,HOLIDAY, EL,LOP
            totalhrs:member?.workhrs +" Hrs "+member?.workmins + " Mins ",
            extrahrs:member?.extrahrs +" Hrs "+member?.extramins + " Mins ",
            comments: "" 
        };
    });
    const getTotal = (type, month) =>{
        var tHrs =0
        var tMins =0
        var eHrs =0
        var eMins =0

        const yearlyData = month?.map((day, idx) => {
             tHrs = tHrs + day.workhrs
             tMins = tMins + day.workmins
             eHrs  = eHrs + day.extrahrs
             eMins  = eHrs + day.extramins
        })
        if(type == "total"){
            return tHrs +" HRs "+ tMins + " Mins"
        }else{
            return eHrs +" HRs "+ eMins + " Mins"
        }
        return ""
    }

    function countWeekends(year, month) {
        // month is 0-based in JS (0 = Jan, 11 = Dec)
        let saturdays = 0;
        let sundays = 0;

        let daysInMonth = new Date(year, month + 1, 0).getDate();

        for (let day = 1; day <= daysInMonth; day++) {
            let d = new Date(year, month, day).getDay();

            if (d === 6) saturdays++;
            if (d === 0) sundays++;
        }

        return { saturdays, sundays };
    }    

    const getLeaves = (yr, month,idx) =>{
        var numLeaves =0
        var numWorkingDays =0

       // Correct destructuring
        const { saturdays, sundays} = countWeekends(yr, idx);        

        const yearlyData = month?.map((day, idx) => {
             if(day.leavetype !=''){
                 numLeaves = numLeaves + 1
             }
             numWorkingDays = numWorkingDays+1
        })

        numWorkingDays = numWorkingDays-numLeaves-sundays-saturdays

        return {numWorkingDays, numLeaves};
    }

    const yearlyData = yearlyAttendance?.map((month, idx) => {
        const  {numWorkingDays, numLeaves}= getLeaves(month[0].date.currentyear, month, idx)
        return {
            select:"",
            id:idx+1,
            month: MonthsName[idx],
            project:userData.project,
            totaldays:numWorkingDays,
            totalhrs: getTotal("total",month ),
            extrahrs: getTotal("extra",month ),
            leaves:numLeaves,        
            comments: "" 
        };
    });   
    
    const handleCheckinCheckout= (action) => {
       
        let encodedJsonValues = {};
        encodedJsonValues.username = userData.username; 
        encodedJsonValues.action = action; //CHECKIN, CHECKOUT

        const tsinsec = Date.now(); // in milliseconds

        if(action == "CHECKIN"){
            encodedJsonValues.intime = today.toLocaleTimeString(); //time hh:mm
            encodedJsonValues.ints = tsinsec; // current time stamp in ts
        }else{
            encodedJsonValues.outtime = today.toLocaleTimeString(); //time hh:mm
            encodedJsonValues.outts = tsinsec; // current time stamp in ts
        }
        encodedJsonValues.currentdatestr = today.toLocaleDateString(); // mmddyyyy in string format

        encodedJsonValues.currentdate= date; // dd on the month
        encodedJsonValues.currentday = today.toLocaleDateString("en-US",{weekday:"long"}); // mmddyyyy
        encodedJsonValues.currentmonth = month; // mmddyyyy
        encodedJsonValues.currentyear = year; // mmddyyyy

        console.log("Encodeded timestamp",encodedJsonValues)
        doCheckinCheckout({...encodedJsonValues});
    };

    return (
        <div className="mytimesheet-container">
            <div className="timesheet-btns-wrapper">
             
                <Button
                    onClick={() => setCurrentView("daily")}
                    className={`timesheet-btn ${
                        currentView === "daily" && "timesheet-btn-active"
                    }`}
                >
                    Today's Attendance
                </Button>
                <Button
                    onClick={() => setCurrentView("monthly")}
                    className={`timesheet-btn ${
                        currentView === "monthly" && "timesheet-btn-active"
                    }`}
                >
                    View Daily/Monthly Attendance
                </Button>
                <Button
                    onClick={() => setCurrentView("yearly")}
                    className={`timesheet-btn ${
                        currentView === "yearly" && "timesheet-btn-active"
                    }`}
                >
                    View Yearly Attendance
                </Button>

                <Button
                    onClick={() => setCurrentView("leaves")}
                    className={`timesheet-btn ${
                        currentView === "leaves" && "timesheet-btn-active"
                    }`}
                >
                    Leaves
                </Button>                                                                              
            </div>
            
            {currentView === "leaves" ? 
                <MyLeaves currentView={currentView}/>:<></>
             }  
            <div className="timesheet-members-wrapper">              
                  {currentView === "daily" ? (
                     <div>
                        <div className="timesheet-members-items" > 
                            <div className="timesheet-members-item-row">
                                <h4 >Mark Todays Attendance</h4>
                            </div>
                            <div className="timesheet-members-item-row">
                                <Button
                                    disabled ={dailyAttendance?.attendancestatus == "CheckedIn"}
                                    onClick={()=>handleCheckinCheckout("CHECKIN")}
                                    
                                >
                                Check In
                                </Button> 
                            </div>
                            <div className="timesheet-members-item-row">
                                <Button
                                    disabled ={dailyAttendance?.attendancestatus == "CheckedOut" || dailyAttendance?.attendancestatus == undefined}
                                    onClick={()=>handleCheckinCheckout("CHECKOUT")}
                                >
                                Check Out
                                </Button> 
                            </div>  
                                                                                                              
                        </div>  
                        <div className="timesheet-members-items" >    
                            Current Status : {isValid(dailyAttendance?.attendancestatus)?dailyAttendance?.attendancestatus:"ABSENT"}               
                        </div>                            
                        <div className="timesheet-members-items" >    
                            Checkin Time : {isValid(dailyAttendance?.attendancestatus)?dailyAttendance?.date.intime:"--"}                 
                        </div>  
                        <div className="timesheet-members-items" >    
                            CheckOut Time : {isValid(dailyAttendance?.attendancestatus)
                                            || dailyAttendance?.attendancestatus=="CheckedIn"?
                                            isValid(dailyAttendance?.date.outtime)?dailyAttendance?.date.outtime:"--":" -- "}                  
                        </div>  
                        <div className="timesheet-members-items" >    
                           Total Work Hrs :{!isValid(dailyAttendance?.workhrs)?" -- ":
                                                   dailyAttendance?.workhrs + " Hrs " + dailyAttendance?.workmins + " Mins"}                  
                        </div>  
                        <div className="timesheet-members-items" >    
                           Extra Hrs :{!isValid(dailyAttendance?.extrahrs)? " -- ":
                                               dailyAttendance?.extrahrs + " Hrs " + dailyAttendance?.extramins + " Mins"}                   
                        </div>                                                                                           
                     </div>   
 
                    ): <></>
                  }
                  {currentView === "monthly" ? (
                      <div className="timesheet-members-title" >
                        <h4 className="timesheet-members-list-title">Daily Timesheet Per Month</h4>
                             <FilterTimeSheet
                                filtername = {"getMonthlyAttendance"}
                                initMonth={month}
                                initYear={year}
                                initProject={"All"}   
                                enableProject
                                enableMonths    
                                handleFilter={getMonthlyAttendance}
                              />   
                        <div className="timesheet-members-table">
                        {monthlyAttendance?.length > 0 ? (
                                <MyTimeSheetTable
                                    titleList={timeSheetTitlesMonthly}
                                    data={monthlyData}
                                    config = {`50px 1fr 1fr 2fr 1fr repeat(${timeSheetTitlesMonthly.length-5}, 1fr)`}
                                />
                            ) : (
                                <Empty style={{ margin: "60px" }} />
                        )}
                         </div>   
                    </div>   
                    ): <></>
                  }
                  {currentView === "yearly" ? (
                      <div className="timesheet-members-title" >
                        <h4 className="timesheet-members-list-title">Monthly Timesheet Per Year</h4>
                        <FilterTimeSheet
                                filtername = {"getYearlyAttendance"}
                                initYear={year}
                                initProject={"All"}   
                                enableProject     
                                handleFilter={getYearlyAttendance}
                        />  
                        <div className="timesheet-members-table">
                        {yearlyData?.length > 0 ? (
                                <MyTimeSheetTable
                                    titleList={timeSheetTitlesYearly}
                                    data={yearlyData}
                                    config = {`50px 1fr 1fr 2fr 1fr repeat(${timeSheetTitlesYearly.length-5}, 1fr)`}
                                />
                            ) : (
                                <Empty style={{ margin: "60px" }} />
                        )}
                         </div>   
                    </div>   
                    ): <></>
                  } 
                                                                                              
            </div>
            <SubUserAddModal />
        </div>
    );
}

export default MyTimeSheet;
